import { trackEvent } from '../../../modules/analytics';
import { AdjustTrackEvent } from '../../../modules/analytics/adjust';

const events = {
  trackSocialClick: () => {
    trackEvent(
      null,
      { eventToken: AdjustTrackEvent.ONBOARDING_STARTED },
      { providers: [(window as any).Adjust] }
    );
  },
};

export default events;
